import * as PropTypes from 'prop-types'

export const UserProfilePropTypes = {
  empId: PropTypes.string,
  isOtherUser: PropTypes.bool,
  isSysAdmin: PropTypes.bool,
  navTo: PropTypes.string,
}
export const targetPropTypes = {
  citrixId: PropTypes.string,
  email: PropTypes.string,
  isCommonUser: PropTypes.bool,
  defaultTarget: PropTypes.string,
  regionIdentifier: PropTypes.string,
  adfsUserInfo: PropTypes.any,
  additionalTargets: PropTypes.any,
  contractCountry: PropTypes.string,
  isInfluencer: PropTypes.bool,
}
export const uidPropTypes = {
  uid: PropTypes.string,
}
